import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'
import i18n from './i18n'

// ── RTL/LTR bootstrap ────────────────────────────────────────────────────────
// On first load, read the persisted language (i18next stores it in localStorage
// as "i18nextLng") and set the <html> dir + lang attributes accordingly so the
// Arabic styles apply instantly without a flicker.
const bootstrapDirection = () => {
  const stored = localStorage.getItem('i18nextLng') || 'en';
  const lang   = stored.startsWith('ar') ? 'ar' : 'en';
  document.documentElement.lang = lang;
  document.documentElement.dir  = lang === 'ar' ? 'rtl' : 'ltr';
};
bootstrapDirection();

// Keep dir/lang in sync whenever the language changes at runtime
i18n.on('languageChanged', (lng: string) => {
  const lang = lng.startsWith('ar') ? 'ar' : 'en';
  document.documentElement.lang = lang;
  document.documentElement.dir  = lang === 'ar' ? 'rtl' : 'ltr';
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
